module.exports = __webpack_public_path__ + "img/changeStonegroup-1.ceab006.webp";